<template>
    <div
        class="dialog-box bg-light mx-auto position-relative pt-16 px-16 rounded shadow-default overflow-y-auto"
        aria-labelledby="dialog-label"
        aria-modal="true"
        role="alert-dialog"
        data-t="dialog-box"
    >
        <div class="text-right">
            <button-link
                icon="close"
                @click="cancel"
            />
        </div>

        <component
            :is="currentDialog"
            class="mb-32"
            v-bind="{ title, description, icon, options }"
            @done="v => $emit('done', v)"
        />
    </div>
</template>

<script>
import AlertDialog from "./components/AlertDialog"
import ButtonLink from "~/components/buttons/ButtonLink"
import ConfirmationDialog from "./components/ConfirmationDialog"
import NotificationDialog from "./components/NotificationDialog"

export default {
    props: {
        title: String,
        description: String,
        mode: {
            type: String,
            default: "alert",
            validator: val =>
                ["alert", "confirmation", "notification"].includes(val),
        },

        icon: {
            type: String,
            default: "info",
        },

        options: {
            type: Object,
            default: () => {
                return {}
            },

            required: false,
        },
    },

    emits: ["done"],

    computed: {
        currentDialog() {
            return `${this.mode}-dialog`
        },
    },

    methods: {
        cancel() {
            this.$emit("done", false)
        },
    },

    components: {
        AlertDialog,
        ButtonLink,
        ConfirmationDialog,
        NotificationDialog,
    },
}
</script>

<style scoped>
.dialog-box {
    max-width: 320px;
    min-width: 320px;
    top: 20%;
}
</style>
